__webpack_require__.p = "/tablica/";